import { styled } from '@tigergraph/app-ui-lib/Theme';

export const InlineBlock = styled('div', {
  display: 'flex',
});
